import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import NewsRoomBackPR from '../../../Component/NewsRoomBackPR.js';
import { Helmet } from 'react-helmet';

import { Link } from 'react-router-dom';

import EPC from "../../../asset/images/media/express_computers.webp";
import BNTW from "../../../asset/images/media/bntw.webp";
import BNW from "../../../asset/images/media/business-news-week.webp";
import MB from "../../../asset/images/media/media_bulletins.webp";
import CMS from "../../../asset/images/media/content_media_solution.webp";
import BND from "../../../asset/images/media/biz_news_desk.webp";
import SBN from "../../../asset/images/media/smart_business_news.webp";
import MIL from "../../../asset/images/media/media-infoline.webp";
import MFN from "../../../asset/images/media/mena-fn.webp";
import IAM from "../../../asset/images/media/indusrial-automation.webp";
import HKP from "../../../asset/images/media/hellokotpad.webp";
import CIL from "../../../asset/images/media/channel_infoline.webp";
import FPR from "../../../asset/images/media/for_pressp_release.webp";
import OWL from "../../../asset/images/media/owler.webp";
import CXO from "../../../asset/images/media/cxo.webp";
import MMN from "../../../asset/images/media/marcamoney.webp";
import APN from "../../../asset/images/media/apn-news.webp";



// import ListItem from '@mui/material/ListItem';
// import ListItemText from '@mui/material/ListItemText';
// import LaunchIcon from '@mui/icons-material/Launch';

// const caseStudyLinks = [
//     {
//         type: "external",
//         linkTo: "https://www.expresscomputer.in/news/decimal-point-analytics-strengthens-leadership-team-to-drive-innovation-and-client-centric-growth/123733/",
//         text: "https://www.expresscomputer.in/news/decimal-point-analytics-strengthens-leadership-team-to-drive-innovation-and-client-centric-growth/123733/"
//     },
//     {
//         type: "external",
//         linkTo: "https://businessnewsthisweek.com/business/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/",
//         text: "https://businessnewsthisweek.com/business/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/"
//     },
//     {
//         type: "external",
//         linkTo: "https://businessnewsweek.in/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/",
//         text: "https://businessnewsweek.in/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/"
//     },
//     {
//         type: "external",
//         linkTo: "https://mediabulletins.com/business/vaibhav-poonekar-named-cto-as-decimal-point-analytics-strengthens-leadership-team/",
//         text: "https://mediabulletins.com/business/vaibhav-poonekar-named-cto-as-decimal-point-analytics-strengthens-leadership-team/"
//     },
//     {
//         type: "external",
//         linkTo: "https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/",
//         text: "https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/"
//     },
//     {
//         type: "external",
//         linkTo: "https://biznewsdesk.com/business/vaibhav-poonekar-takes-the-helm-as-cto-in-decimal-point-analytics-leadership-reshuffle/",
//         text: "https://biznewsdesk.com/business/vaibhav-poonekar-takes-the-helm-as-cto-in-decimal-point-analytics-leadership-reshuffle/"
//     },
//     {
//         type: "external",
//         linkTo: "https://smartbusinesnews.com/business/decimal-point-analytics-promotes-vaibhav-poonekar-to-cto-in-continued-leadership-growth/",
//         text: "https://smartbusinesnews.com/business/decimal-point-analytics-promotes-vaibhav-poonekar-to-cto-in-continued-leadership-growth/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.mediainfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions",
//         text: "https://www.mediainfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions"
//     },
//     {
//         type: "external",
//         linkTo: "https://menafn.com/1109397004/Decimal-Point-Analytics-Elevates-Vaibhav-Poonekar-To-CTO-In-Key-Internal-Leadership-Promotions",
//         text: "https://menafn.com/1109397004/Decimal-Point-Analytics-Elevates-Vaibhav-Poonekar-To-CTO-In-Key-Internal-Leadership-Promotions"
//     },
//     {
//         type: "external",
//         linkTo: "https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/",
//         text: "https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.industrialautomationindia.in/news/vaibhav-poonekar-appointed-cto-decimal-point-analytics-leadership-promotions-ai-automation",
//         text: "https://www.industrialautomationindia.in/news/vaibhav-poonekar-appointed-cto-decimal-point-analytics-leadership-promotions-ai-automation"
//     },
//     {
//         type: "external",
//         linkTo: "https://hellokotpad.com/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/",
//         text: "https://hellokotpad.com/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.channelinfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/",
//         text: "https://www.channelinfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.forpressrelease.com/forpressrelease/650373/4/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions",
//         text: "https://www.forpressrelease.com/forpressrelease/650373/4/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.owler.com/reports/decimal-point-analytics-private-limited/decimal-point-analytics-strengthens-leadership-tea/1743782280546",
//         text: "https://www.owler.com/reports/decimal-point-analytics-private-limited/decimal-point-analytics-strengthens-leadership-tea/1743782280546"
//     },
//     {
//         type: "external",
//         linkTo: "https://cxotoday.com/press-release/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/",
//         text: "https://cxotoday.com/press-release/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.marcamoney.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto/",
//         text: "https://www.marcamoney.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto/"
//     },
//     {
//         type: "external",
//         linkTo: "https://apnnews.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/",
//         text: "Decimal Point Analytics Elevates Vaibhav Poonekar to CTO in Key Internal Leadership Promotions - APN News"
//     },
// ];


export default function VaibhavPoonekarCTO() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>DPA Announces Key Leadership Promotions | April 2025</title>
                <meta name="description" content="Decimal Point Analytics elevates Vaibhav Poonekar to CTO and announces multiple leadership promotions to enhance innovation, client value, and operational excellence." />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    News Room
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Decimal Point Analytics Elevates Vaibhav Poonekar To CTO In Key Internal Leadership Promotions
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <Grid container direction="row"
                            justifyContent="center"
                            alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='whitebx'>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <Link to="/" className="link">Decimal Point Analytics</Link> (DPA), a leading provider of AI-driven financial solutions, is pleased to announce a series of leadership promotions aimed at enhancing client engagement, operational excellence, and continued innovation. As part of this strategic initiative, Vaibhav Poonekar has been elevated to Chief Technology Officer (CTO), reinforcing DPA’s commitment to nurturing and advancing talent from within the organization.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Vaibhav joined DPA as AVP – Automation & Development Lead, making significant strides in AI-driven analytics and automation. His leadership in enterprise automation and technology alignment earned him successive promotions to VP and SVP. Now, as CTO, he will spearhead DPA’s technology strategy, leveraging AI, data engineering, and financial modeling to strengthen the firm’s technological foundation and client-centric solutions.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        In addition to Vaibhav’s elevation, DPA has promoted several key team members across its core business functions, reinforcing its commitment to internal career growth and leadership development:
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <ul>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Nikesh Satra – Executive Vice President, Research and Data Operations
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Prasad Nawathe – Executive Vice President, Investor Relations
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Pravas Kumar Sahoo – Executive Vice President, Valuation and Advisory
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Shyam Pardeshi – Executive Vice President, Research and Data Operations
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Ankit Rana – Senior Vice President, Research and Data Operations
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Josey Philip – Vice President, Research and Data Operations
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Aman Srivastava – Assistant Vice President, Research and Automation
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Malcolm Mascarenhas – Assistant Vice President, Compliance
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Pavan Panchal – Assistant Vice President, Research and Automation
                                                </Typography>
                                            </li>
                                        </ul>
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Shailesh Dhuri, CEO of Decimal Point Analytics, commented: “At DPA, our people are the cornerstone of our success. These promotions reflect our investment in nurturing talent and building a leadership team that combines deep domain expertise with innovative thinking. As we scale new heights in AI and financial analytics, this strengthened team will ensure we continue delivering exceptional value to clients worldwide.”
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        DPA remains committed to recognizing and empowering its talented professionals, ensuring a seamless integration of cutting-edge technology with deep domain expertise. These leadership moves will further accelerate the firm’s ability to deliver transformative solutions and sustain long-term client success.
                                    </Typography>

                                    <Box mt={1}>
                                        <Typography variant='h4' className='blue jst' gutterBottom>
                                            About Decimal Point Analytics
                                        </Typography>
                                    </Box>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <Link to="/" className="link">Decimal Point Analytics</Link> is a technology-driven data analytics and AI solutions firm, empowering businesses with actionable insights and automation. With expertise in financial analytics, AI-driven decision support, and digital transformation, we enable clients to optimise operations, mitigate risks, and drive growth. Our global team blends deep domain knowledge with cutting-edge technology, delivering scalable solutions across financial services, healthcare, CPG, and other industries. Headquartered in India, with a presence in the US and UK, we are committed to innovation, precision, and excellence in data-driven decision-making.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Our commitment to innovation and excellence has earned us multiple industry accolades. Decimal Point Analytics has been featured in Dun & Bradstreet's premier publication, Leading SMEs of India 2024 & 2022. We were recognised as the ISV of the Year 2023 by Oracle Global Leaders, highlighting our outstanding contributions to the industry. The Indo-French Chamber of Commerce and Industry (IFCCI) awarded us the title of Indian SME of the Year, while ET Edge acknowledged our excellence in innovation in 2023. Additionally, CEO Insights magazine has named us one of the Top 10 Brands in Finance, further reinforcing our position as a leader in data analytics and AI-driven solutions.
                                    </Typography>

                                    <Typography variant='h6' className='black' gutterBottom>
                                        For more information, visit <Link to="/" className="link">www.decimalpointanalytics.com</Link>
                                    </Typography>

                                </Box>
                            </Grid>
                        </Grid>

                    </Box>

                    {/* <Box>
                        <Box className='graybbx linkbx' mt={2}>
                            <Grid container spacing={2} alignItems="center" justifyContent='flex-start'>
                                {caseStudyLinks.map((item, index) => (
                                    <Grid item lg={2} md={4} sm={6} xs={12} key={index}>
                                        {item.type === "internal" ? (
                                            <Link to={item.linkTo} className="link">
                                                <Box className="whitebx">
                                                    <ListItem
                                                        secondaryAction={<LaunchIcon fontSize="small" className="black" />}
                                                    >
                                                        <ListItemText primary={item.text} />
                                                    </ListItem>
                                                </Box>
                                            </Link>
                                        ) : (
                                            <a
                                                href={item.linkTo}
                                                className="link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Box className="whitebx">
                                                    <ListItem
                                                        secondaryAction={<LaunchIcon fontSize="small" className="black" />}
                                                    >
                                                        <ListItemText primary={item.text} />
                                                    </ListItem>
                                                </Box>
                                            </a>
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box> */}

                    <Box>
                        <Box className='graybbx' mt={2}>
                            <Grid container spacing={0} alignItems="center" justifyContent='center'>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.expresscomputer.in/news/decimal-point-analytics-strengthens-leadership-team-to-drive-innovation-and-client-centric-growth/123733/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + EPC + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://businessnewsthisweek.com/business/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BNTW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://businessnewsweek.in/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BNW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://mediabulletins.com/business/vaibhav-poonekar-named-cto-as-decimal-point-analytics-strengthens-leadership-team/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + MB + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CMS + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://biznewsdesk.com/business/vaibhav-poonekar-takes-the-helm-as-cto-in-decimal-point-analytics-leadership-reshuffle/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BND + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://smartbusinesnews.com/business/decimal-point-analytics-promotes-vaibhav-poonekar-to-cto-in-continued-leadership-growth/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + SBN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.mediainfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + MIL + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://menafn.com/1109397004/Decimal-Point-Analytics-Elevates-Vaibhav-Poonekar-To-CTO-In-Key-Internal-Leadership-Promotions" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + MFN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                 <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://contentmediasolution.com/business/decimal-point-analytics-announces-leadership-elevation-vaibhav-poonekar-steps-in-as-cto/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CMS + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.industrialautomationindia.in/news/vaibhav-poonekar-appointed-cto-decimal-point-analytics-leadership-promotions-ai-automation" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + IAM + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://hellokotpad.com/business/decimal-point-analytics-appoints-vaibhav-poonekar-as-cto-amidst-strategic-leadership-moves/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + HKP + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.channelinfoline.com/movement/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CIL + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.forpressrelease.com/forpressrelease/650373/4/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + FPR + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.owler.com/reports/decimal-point-analytics-private-limited/decimal-point-analytics-strengthens-leadership-tea/1743782280546" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + OWL + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://cxotoday.com/press-release/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CXO + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.marcamoney.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + MMN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.apnnews.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + APN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>  
                            </Grid>
                        </Box>
                    </Box>



                    <Box mt={2}>
                        <NewsRoomBackPR />
                    </Box>

                </Container>
            </Box>

        </>
    );
}
